<script setup lang="ts">
import { useI18n } from "vue-i18n";

const emit = defineEmits(["linkClick"]);

const { t } = useI18n();

withDefaults(
  defineProps<{
    productLink: string;
    pricingLink: string;
    partnersLink: string;
    companyLink: string;
    securityLink: string;
    mobile?: boolean;
  }>(),
  {
    mobile: false,
  },
);
</script>

<template>
  <a
    :href="productLink"
    class="font-medium transition-colors duration-200"
    :class="
      mobile
        ? 'block w-full border-b border-black/10 py-5 font-serif text-3xl text-primary-black hover:text-primary-black/60'
        : 'text-lg text-black/72 hover:text-black'
    "
    @click="emit('linkClick')"
  >
    {{ t("website_navigation.product") }}
  </a>

  <a
    :href="pricingLink"
    class="font-medium transition-colors duration-200"
    :class="
      mobile
        ? 'block w-full border-b border-black/10 py-5 font-serif text-3xl text-primary-black hover:text-primary-black/60'
        : 'text-lg text-black/72 hover:text-black'
    "
    @click="emit('linkClick')"
  >
    {{ t("website_navigation.pricing") }}
  </a>

  <a
    :href="securityLink"
    class="font-medium transition-colors duration-200"
    :class="
      mobile
        ? 'block w-full border-b border-black/10 py-5 font-serif text-3xl text-primary-black hover:text-primary-black/60'
        : 'text-lg text-black/72 hover:text-black'
    "
    @click="emit('linkClick')"
  >
    {{ t("website_navigation.security") }}
  </a>

  <a
    :href="partnersLink"
    class="font-medium transition-colors duration-200"
    :class="
      mobile
        ? 'block w-full border-b border-black/10 py-5 font-serif text-3xl text-primary-black hover:text-primary-black/60'
        : 'text-lg text-black/72 hover:text-black'
    "
    @click="emit('linkClick')"
  >
    {{ t("website_navigation.partners") }}
  </a>

  <a
    :href="companyLink"
    class="font-medium transition-colors duration-200"
    :class="
      mobile
        ? 'block w-full border-b border-black/10 py-5 font-serif text-3xl text-primary-black hover:text-primary-black/60'
        : 'text-lg text-black/72 hover:text-black'
    "
    @click="emit('linkClick')"
  >
    {{ t("website_navigation.company") }}
  </a>
</template>
